import React, { useMemo } from 'react';
import './style.scss';
import BattleActionCardButton, { CardButtonStates } from './cardButton';
import { CardNames } from 'shared';
import {
  ColorSchema,
  getColorSchemaByNFTColors
} from '../../../../../../utils/color';
import { IUsePlayer } from '../usePlayer';

interface Props {
  position: 'top' | 'bottom';
  player: IUsePlayer;
  onClick?: (card: CardNames) => void;
}

type ButtonSetting = {
  state: CardButtonStates;
  clickable: boolean;
};

type ButtonsSettings = {
  rock: ButtonSetting;
  paper: ButtonSetting;
  scissors: ButtonSetting;
};

const BattleActionCardsBlock = ({ position, player, onClick }: Props) => {
  const schema = useMemo<ColorSchema>(() => {
    return getColorSchemaByNFTColors(
      player.data.colors,
      position === 'top' ? 'green' : 'blue'
    );
  }, [player.data.colors, position]);

  const controlsStyle = {
    background: schema.backgrounds.main,
    boxShadow: `0 4px 0 0 ${schema.shadows.main}`
  };

  const buttonsState = useMemo<ButtonsSettings>(() => {
    const getState = (count: number, cardName: CardNames): CardButtonStates => {
      if (count <= 0) return CardButtonStates.DISABLED;
      if (player.movedWith !== cardName) return CardButtonStates.ACTIVE;
      return CardButtonStates.PRESSED;
    };

    const clickable = !!onClick;

    return {
      rock: {
        state: getState(player.cards.rock, CardNames.ROCK),
        clickable: clickable && !player.movedWith
      },
      paper: {
        state: getState(player.cards.paper, CardNames.PAPER),
        clickable: clickable && !player.movedWith
      },
      scissors: {
        state: getState(player.cards.scissors, CardNames.SCISSORS),
        clickable: clickable && !player.movedWith
      }
    };
  }, [player.cards, player.movedWith, !!onClick]);

  return (
    <div className='fight-action-cards' style={controlsStyle}>
      <BattleActionCardButton
        cardsAmount={player.cards.rock}
        type={CardNames.ROCK}
        state={buttonsState.rock.state}
        clickable={buttonsState.rock.clickable}
        schema={schema}
        onClick={onClick}
      />
      <BattleActionCardButton
        cardsAmount={player.cards.paper}
        type={CardNames.PAPER}
        state={buttonsState.paper.state}
        clickable={buttonsState.paper.clickable}
        schema={schema}
        onClick={onClick}
      />
      <BattleActionCardButton
        cardsAmount={player.cards.scissors}
        type={CardNames.SCISSORS}
        state={buttonsState.scissors.state}
        clickable={buttonsState.scissors.clickable}
        schema={schema}
        onClick={onClick}
      />
    </div>
  );
};

export default BattleActionCardsBlock;
